import React from 'react';

import styles from './SimpleVideoPlayer.module.scss';

const LoadingOverlay = () => {
  return (
    <div className={styles.loadingOverlay}>
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 384 216"
      >
        <circle fill="#2979ff" stroke="none" cx="180" cy="100" r="3.2">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle fill="#2979ff" stroke="none" cx="192" cy="100" r="3.2">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle fill="#2979ff" stroke="none" cx="204" cy="100" r="3.2">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
        <text
          fontFamily="Roboto, sans-serif"
          textAnchor="middle"
          fontSize="12"
          fontWeight="lighter"
          fill="#737d9c"
        >
          <tspan x="192" y="130">
            Your Video is Loading
          </tspan>
        </text>
      </svg>
    </div>
  );
};

export default LoadingOverlay;
